module.exports = __webpack_public_path__ + "static/media/calendario.c1a2c306.jpeg";